import React from "react";
import { S3_ENDPOINT } from "../../utils";

const CustomIcon = ({ icon }) => {
  return <img src={`${S3_ENDPOINT}/${icon}.png`} className="icon" />;
};

export default CustomIcon;
